export const EXPRESS_STRIPE_LAYOUT = Object.freeze({
    maxColumns: 2,
    maxRows: 1,
    overflow: 'auto',
});

export function expressColumns(width, gap, count = EXPRESS_STRIPE_LAYOUT.maxColumns) {
    const minimum = width < 464 ? 140 : 110;
    const capacity = Math.max(1, Math.floor((width + gap) / (minimum + gap)));
    return Math.min(count, EXPRESS_STRIPE_LAYOUT.maxColumns, capacity);
}
